import { CssBaseline, ThemeProvider } from '@mui/material'
import type { JSX } from 'react'
import { type PropsWithChildren, useMemo } from 'react'
import { usePlaygroundSettingValues } from '../../store/editTools/usePlaygroundSettingValues.js'
import { createTheme } from './theme.js'

export const PlaygroundThemeProvider = ({
  children,
}: PropsWithChildren): JSX.Element => {
  const { viewportColorLight, viewportColorDark } = usePlaygroundSettingValues()
  const appTheme = useMemo(
    () => createTheme(viewportColorLight, viewportColorDark),
    [viewportColorLight, viewportColorDark]
  )

  return (
    <ThemeProvider
      theme={appTheme}
      modeStorageKey="li.fi-widget-playground-mode"
      colorSchemeStorageKey="li.fi-widget-playground-color-scheme"
      disableTransitionOnChange
    >
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  )
}
